import { render, staticRenderFns } from "./FormTextbox.vue?vue&type=template&id=006169d2"
import script from "./FormTextbox.vue?vue&type=script&lang=js"
export * from "./FormTextbox.vue?vue&type=script&lang=js"
import style0 from "./FormTextbox.vue?vue&type=style&index=0&id=006169d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports